import { adimRaporlari, adimRaporuVar } from "@oasis/domain";
import { sayfaEtiketi, type SayfaAraligi } from "@/components/pdf-sayfa";

type RafAdimi = { ad: string; loglar: readonly { tip: string; dokumanId: string | null; sayfa?: SayfaAraligi | null }[] };

/**
 * D-074 Faz 2: File shelf "Repair task" çipleri. Adımın her raporu (belge × aralık) bir çip; eski `true` → "<adım> — PDF ✔".
 * Anahtar sırası `docs`'unkidir; `fitup` ve `weldmap` ayrı satırlardır. Aynı belgenin adım kayıtlarındaki aralıklar tekil sırayla
 * birer çip olur (aralıksız kayıt "PDF"); adım kaydı olmayan kimlik tek, aralıksız çiptir.
 */
export function rafRaporCipleri(docs: Record<string, unknown>, adimlar: readonly RafAdimi[]): string[] {
  const cipler: string[] = [];
  for (const k of Object.keys(docs)) {
    if (k === "fitup" || k === "weldmap" || !adimRaporuVar(docs, k)) continue;
    const idler = adimRaporlari(docs, k);
    if (!idler.length) {
      cipler.push(`${k} — PDF ✔`);
      continue;
    }
    const adim = adimlar.find((x) => x.ad === k);
    for (const id of idler) {
      const araliklar: (SayfaAraligi | null)[] = [];
      const gorulen = new Set<string>();
      for (const l of adim?.loglar ?? []) {
        if (l.tip !== "pdf" || l.dokumanId !== id) continue;
        const a = l.sayfa ?? null;
        const anahtar = a ? `${a.sayfaBas}-${a.sayfaSon}` : "tam";
        if (gorulen.has(anahtar)) continue;
        gorulen.add(anahtar);
        araliklar.push(a);
      }
      for (const a of araliklar.length ? araliklar : [null]) cipler.push(`${k} — PDF${a ? ` · ${sayfaEtiketi(a)}` : ""} ✔`);
    }
  }
  return cipler;
}
